module.exports = "/_next/static/images/PrivacyPortal@2x-2d8dec100d257f01c5e40d87108fb190.png";